import {Ajax} from './components/Common';
$('.board-item').hover(function () {
    $(this).find('.option').toggleClass('d-block');
});
var currentBoardId;
var currentBoardItem;
var category = $('select[name="category"]');
var name = $('input[name="fullname"]');
var position = $('input[name="position"]');
var school = $('input[name="school"]');
var id = $('input[name="id"]');

$('.delete-board').on('click', function () {
    var html = ''
        + '<p> Are you sure you want to delete this item?</p>'
        + '<a href="#" class="confirm-delete-board btn btn-sm btn-light border" data-dismiss="modal"><i class="fas fa-check text-primary"></i> Yes</a>'
    $('#mdlPrompt .modal-body').html(html);
    currentBoardId = $(this).data('id');
    currentBoardItem = $(this).closest('.board-item');
});
$('#mdlPrompt').on('click', '.confirm-delete-board', function () {
    $.ajax({
        type: 'post',
        url: 'delete-board',
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            'id': currentBoardId
        },
        success: function (data) {
            currentBoardItem.remove();
        },
        error: function (data) {
            alert('error')
        }
    });
});
$('.edit-board').on('click', function () {
    currentBoardItem = $(this).closest('.board-item');
    currentBoardId = $(this).data('id');
    category.closest('.col-12').hide();
    name.val($(this).closest('.board-item').find('.name').text());
    position.val($(this).closest('.board-item').find('.position').text());
    school.val($(this).closest('.board-item').find('.school').text());
    id.val($(this).data('id'));
    $('#mdlAddBoard .modal-title').text('Edit Board');
    $('.save-board').addClass('d-none');
    $('.update-board').removeClass('d-none');
});
$('.update-board').on('click', function () {
    $.ajax({
        type: 'post',
        url: '/update-board',
        data: new FormData($("#frmAddBoard")[0]),
        processData: false,
        contentType: false,
        success: function (data) {
            if (data != "") {
                currentBoardItem.find('img').attr("src",'/img/board/' + data);
            }
            currentBoardItem.find('.name').text(name.val());
            currentBoardItem.find('.position').text(position.val());
            currentBoardItem.find('.school').text(school.val());
            $('#mdlAddBoard').modal('hide');
        },
        error: function () {
            alert('error');
        }
    });
});
$('.add-board').on('click', function () {
    category.closest('.col-12').show();
    $('#mdlAddBoard .modal-title').text('Add Board');
    $('.update-board').addClass('d-none');
    $('.save-board').removeClass('d-none');
    name.val('');
    position.val('');
    school.val('');
    $('input[name="picture"]').val('');
});

$('.add-banner').on('click', function(){
    $('input[name="banner"]').trigger('click');
});

// function to preview image
function readURL(input) {

    if (input.files && input.files[0]) {
      var reader = new FileReader();
  
      reader.onload = function(e) {
        $('.banner').attr('src', e.target.result);
      }
  
      reader.readAsDataURL(input.files[0]);
    }
}
// upon image select
$('input[name="banner"]').change(function() {
    readURL(this);
});
// update banner
$('input[name="newbanner"]').change(function() {
    readURL(this);
});
$('.update-banner').on('click', function(){
    $('input[name="newbanner"]').trigger('click');
});

// save announcement
$('.save-announcement').on('click', function(e){
    e.preventDefault();
    var banner = $('input[name="banner"]');
    var title = $('input[name="title"]');
    var content = $('textarea[name="content"]');
    content.text($('#editor').html());
    if(banner.val() == "" || title.val() == "" || content.val() == ""){
        var html = ''
            + '<p>Please fill all fields</p>'
            + '<a href="#" class="btn btn-sm btn-light border" data-dismiss="modal"><i class="fas fa-check text-primary"></i> Okay</a>'
        $('#mdlPrompt .modal-body').html(html);
        $('#mdlPrompt').modal('show');
    }
    else{
        // $('#frmAnnouncement').submit();
        $(this).closest('form').submit();
    }
});
$('.delete-announcement').on('click', function(e){
    e.preventDefault();
    var html = ''
            + '<p>Are you sure you want to delete this item</p>'
            + '<a href="/delete-announcement/' + $(this).data('id') +'" class="btn btn-sm btn-light border"><i class="fas fa-check text-primary"></i> Yes</a>'
    $('#mdlPrompt .modal-body').html(html);
    $('#mdlPrompt').modal('show');
})

function deleteItem(url) {
    var html = ''
            + '<p>Are you sure you want to delete this item</p>'
            + '<a href="' + url + '" class="btn btn-sm btn-light border"><i class="fas fa-check text-primary"></i> Yes</a>'
    $('#mdlPrompt .modal-body').html(html);
    $('#mdlPrompt').modal('show');
}
// edit admin user
$('.editUser').on('click', function(){
    var currentRow = $(this).closest('.row');
    var editModal = $('#mdlEditUser');
    editModal.find('input[name="name"]').val(currentRow.find('.name').text());
    editModal.find('select[name="type"]').val(currentRow.find('.type').text());
    editModal.find('input[name="email"]').val(currentRow.find('.email').text());
    editModal.find('input[name="id"]').val(currentRow.find('.id').text());
});

var currentTicketRow;
function showLoading(){
    $('#loading').removeClass('d-none');
}
function hideLoading(){
    $('#loading').addClass('d-none');
}
$('.showLoading').on('click', function(){
    showLoading();
});
function updatedRow(row){
    row.addClass('updated');
    setTimeout(function() {
        row.removeClass("updated");
    }, 1000);
}

$(".alert").fadeTo(5000, 500).slideUp(500, function(){
    $(".alert").slideUp(500);
});

$('.send-invoices').on('click', function(e){
    e.preventDefault()
    let html = '<p>The system is now sending the invoices in the background.</p>';
    let ajax = new Ajax($(this), html);
});
$('.assign-invoice-paid-renewals').on('click', function(e){
    e.preventDefault()
    let html = '<p>The system is now assigning the invoices in the background.</p>';
    let ajax = new Ajax($(this), html);
});
